import { WidgetsAbstract } from "./widgets/widgets.abstract";

export abstract class AbstractClone {
    /**
     * Recursive clone method 
     * Overcomes problems deserializing a typescript widget from JSON through HttpClient
     * @param origWidget Origin node to clone from, possibly loaded from a JSON file, without typing
     * @param destWidget Destination widget
     * @param isDragNDrop When cloning from layout for palette: false. When drag and dropping to create new instance: true. 
     * @param isInsideQuestion True if we are cloning inside a Question
     * @param parentId Id of the parent of the current node / undefined for top node
     */
    abstract cloneFromJS(origWidget: any, destWidget: WidgetsAbstract, isDragNDrop: boolean, isInsideQuestion: boolean, parentId: string | undefined);
}
